<template>
  <div class="ReportList">
    <h2 style="font-size: 24px; color: #262626; font-weight: bold;margin-bottom: 24px">报告中心</h2>
    <a-card size="small" title="测评任务列表">
      <div class="select">
        <a-select class="option" placeholder="筛选年份" style="width: 120px" @change="handleChangeGrade" allowClear @keyup.enter.native="searchHandle">
          <a-select-option v-for="item in yearsList" :key="item" :value="item">{{item}}</a-select-option>
        </a-select>
        <a-input placeholder="搜索测评任务" v-model="taskName" @keyup.enter.native="searchHandle"/>
        <a-button class="commit" type="primary" @click="searchHandle">查询</a-button>
      </div>
      <a-table :dataSource="taskList" :columns="columns" :pagination="false" :rowKey="row => row.qid">
        <div slot="time" slot-scope="text, record">
          <span style="color: #595959">{{record.start_time}} —— {{record.end_time}}</span>
        </div>
        <div slot="operation" slot-scope="text, record">
          <div class="operation">
            <span style="color: #1890FF;cursor: pointer;" @click="viewUndetected(record)">进入报告库</span>
            <span v-if="record.isCrisis && (roleID === 1 || roleID === 2)" style="color: #1890FF;cursor: pointer;margin-top: 4px" @click="crisisHandle(record)">任务危机管理</span>
          </div>
        </div>
      </a-table>
    </a-card>
    <a-drawer :width="1200" :visible="visible" :body-style="{ paddingBottom: '80px', paddingTop: '32px' }" :destroyOnClose="true" :closable="false" @close="onClose">
      <span class="back" @click="onClose" style="margin-left: 40px;padding: 8px;box-sizing: border-box;">
        <a-icon type="left" />
        返回
      </span>
      <drawer-view></drawer-view>
    </a-drawer>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex'
	import URL from '@/store/url'
  import DrawerView from './DrawerView'
  export default {
    name: 'ReportList',
    data () {
      return {
        visible: false,
        years: null,
        taskName: null,
        yearsList: null,
        taskList: null,
				roleID: null,
        columns: [
          {
            title: '任务名称',
            dataIndex: 'title',
            width: '25%'
          },
          {
            title: '时间范围',
            dataIndex: 'start_time',
            width: '55%',
            scopedSlots: { customRender: 'time' }
          },
          {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' }
          }
        ]
      }
    },
    computed: {
      ...mapState([
        'schoolTaskScale',
        'asyncFlag',
				'teacherAdmin',
				'teacherDQID',
        'teacherENDTIME'
      ])
    },
    methods: {
      ...mapActions([
        'getSchoolTaskScale',
        'asyncTeacherData'
      ]),
      ...mapMutations([
        'setTaskReport'
      ]),
      handleChangeGrade (value) { // 选择年份
        this.years = value
      },
      searchHandle () { // 查询
        this.taskList = this.schoolTaskScale.filter((item) => !this.years ? true : item.years === this.years).filter((item) => !this.taskName ? true : item.title.indexOf(this.taskName) !== -1)
      },
      async viewUndetected (record) { // 查看报告库
        record.type = 1 // 单校
				record.list = []
        this.visible = true // 打开抽屉
        let topic = record.topics.split(',')
        topic.map(item => record.list.push(parseInt(item)))
        this.setTaskReport(record)
				this.asyncData(record)
      },
			crisisHandle (record) { // 任务危机管理
				let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
				this.asyncData(record)
				window.open(`${URL.TO_CRISIS}crisisChoose?schoolId=${this.teacherAdmin.school_id}&teacherUid=${this.teacherAdmin.uid}&city=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&schoolName=${this.teacherAdmin.school_name}&minGrade=${userInfo.min_grade}&maxGrade=${userInfo.max_grade}&roleId=${userInfo.role_id}&jwt=${this.teacherAdmin.jwt}&dqid=${record.qid}&teacherDqid=${this.teacherDQID}&teacherEndtime=${this.teacherENDTIME}&cp=${userInfo.OPEN_TEACHER_CP}&sid=${record.sid === 993548 ? 993548 : 993541}&start_time=${record.start_time}&end_time=${record.end_time}`)
			},
      onClose () { // 关闭抽屉
        this.visible = false
      },
			async asyncData (record) { // 同步无效数据
				if (record.isCrisis && record.sid !== 995002) {
					await this.asyncTeacherData({SID: record.sid, DQ_ID: record.qid})
					if (!this.asyncFlag) {
						this.$message.error('更新团体报告无效数据失败')
					}
				}
			}
    },
    async mounted () {
			this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
      await this.getSchoolTaskScale()
      this.yearsList = []
      if (this.schoolTaskScale) {
        this.schoolTaskScale.map(item => {
					// 筛选框年份
          item.years = item.start_time.slice(0, 4)
          if (!this.yearsList.includes(item.years)) {
            this.yearsList.push(item.years)
          }
					// (群体分发 & 包含危机量表) ==> 显示“任务危机管理”按钮
					if (item.type === 3) {
						let crisis = [993541, 993544, 993548, 995000, 995002]
						let topic = item.topics.split(',')
						topic.map(val => {
							if (crisis.includes(parseInt(val))) {
								item.isCrisis = true
								item.sid = parseInt(val)
							}
						})
					}
        })
        this.taskList = this.schoolTaskScale
      }
    },
    components: {
      DrawerView
    }
  }
</script>

<style>
.ReportList{
  width: 976px;
}
.ReportList>p{
  font-size:24px;
  font-weight:500;
  color:rgba(38,38,38,1);
  line-height:24px;
}
.ReportList .reportView{
  margin-top: 24px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(232,232,232,1);
}
.ReportList .reportView .ant-tabs-ink-bar{
  width: 56px;
  background-color: #51BF94;
}
.ant-tabs-nav .ant-tabs-tab-active {
    color: #262626;
    font-weight: 500;
}
.ant-table-pagination.ant-pagination {
  float: right;
  margin: 16px 16px;
}
.ant-card-small > .ant-card-head {
  padding: 7px 24px;
  box-sizing: border-box;
}
.ant-table-thead > tr > th, .ant-table-tbody > tr > td {
  padding: 16px 24px;
  box-sizing: border-box;
}
.ReportList .select{
  display: flex;
  margin: 24px;
}
.ReportList .select .ant-btn-primary{
  width:64px;
  height:32px;
  background: rgba(81,191,148,1);
  border-radius: 4px;
  border-color: rgba(81,191,148,1);
}
.ReportList .select .option{
  width: 120px;
  margin-right: 16px;
}
.ReportList .select > input{
  width: 180px;
  height: 32px;
  margin-right: 14px;
}
.ReportList .select .ant-btn > span {
  color: #ffffff;
}
.back:hover {
  background: #F5F5F5;
  cursor: pointer;
}
.ReportList .operation {
  display: flex;
  flex-direction: column;
}
</style>